import React from "react";
import { truncateText, formatDate, getData } from "../util";
import SendToProblemQueue from "./SendToProblemQueue";
import { Link } from "react-router-dom";
import BrowserBadge from "./BrowserBadge";
import ProbablyNotTestBadge from "./ProbablyNotTestBadge";
import { isBrowserCapture } from "../util/splitQueue";

const QueueItem = ({
  item,
  remove,
  qType,
  user,
  callback,
  onSelected,
  showCheckbox = false,
}) => {
  let country = "us";
  if (item.url.endsWith("#uk")) {
    country = "uk";
  } else if (item.url.endsWith("#au")) {
    country = "au";
  } else if (item.url.endsWith("#fr")) {
    country = "fr";
  } else if (item.url.endsWith("#de")) {
    country = "de";
  }
  let href;

  if (qType === "new_queue") {
    href = `/screens/${encodeURIComponent(item.url)}?qid=${item.id}&zoom=in#${
      item.platform === "mobile" ? "mobile-start" : "desktop-start"
    }`;
  } else {
    href = `/screens/${encodeURIComponent(item.url)}?qid=${item.id}&filterBy=${
      item.platform === "mobile" ? "mobile" : "desktop"
    }&zoom=in#${item.platform === "mobile" ? "mobile-start" : "desktop-start"}`;
  }
  return (
    <div className="mb3 flex flex-row">
      {showCheckbox && (
        <div className="mr3">
          <input
            type="checkbox"
            value={item.id}
            checked={item.checked}
            onChange={onSelected ? onSelected : null}
          />
        </div>
      )}
      <div>
        <span title={item.url}>
          {truncateText(
            item.url.replace("http://", "").replace("https://", ""),
            50
          )}
        </span>{" "}
        {qType !== "new_queue" && (
          <>
            {item.platform === "mobile" && <span>📱</span>}
            {item.platform === "desktop" && <span>💻</span>}
          </>
        )}
        <a title={item.url} href={href} target="_blank">
          See screens
          {/* ({item.totalCount} items in queue) */}
        </a>
        {item.landingPage && (
          <div>
            <b>Landing Page</b>
          </div>
        )}
        {item && item.tests && item.tests.length !== 0 && (
          <div>
            <Link to={`/screens/${encodeURIComponent(item.url)}/tests`}>
              {item.tests.length} {item.tests.length === 1 ? "test" : "tests"}{" "}
              currently published or in queues
            </Link>
          </div>
        )}
        <div>
          {<b className="mr2 ttu">{country} &middot;</b>}
          {qType === "new_queue" && (
            <>
              <span className="purple b">
                {item.type === "started_test" && <>Started</>}
                {item.type === "ended_test" && <>Ended</>}
                {item.type === "qa" && <>Manual Review</>}
              </span>{" "}
              &middot; {formatDate(item.ctime)}
            </>
          )}
          {qType === "started" && (
            <span>Started on {formatDate(item.ctime)}</span>
          )}
          {qType === "ended" && <span>Ended on {formatDate(item.ctime)}</span>}
          {(qType === "problem" || qType === "qa") && (
            <span>Added on {formatDate(item.ctime)}</span>
          )}
          {isBrowserCapture(item) && <BrowserBadge className="ml2" />}
          {item.probablyNotATest && (
            <ProbablyNotTestBadge className="ml2" summary={item.checkSummary} />
          )}
        </div>
        {(item.oldestCtime || item.newestCtime) && (
          <div>
            {[
              item.oldestCtime
                ? `Oldest item: ${formatDate(item.oldestCtime)}`
                : null,
              item.newestCtime
                ? `Newest item: ${formatDate(item.newestCtime)}`
                : null,
            ]
              .filter(Boolean)
              .join(" | ")}
          </div>
        )}
        <div className="f7">
          <SendToProblemQueue
            qid={item.id}
            platform={item.platform}
            url={item.url}
            user={user}
            callback={callback}
          />
          {item.comment && <div>{item.comment}</div>}
        </div>
      </div>
    </div>
  );
};

export default QueueItem;
